"use strict";

exports.__esModule = true;
exports.useLocale = useLocale;
exports.default = exports.withLocale = void 0;

var _react = require("react");

var _Context = _interopRequireDefault(require("./Context"));

var _with = _interopRequireDefault(require("./with.js"));

exports.withLocale = _with.default;

var _Provider = _interopRequireDefault(require("./Provider.js"));

exports.default = _Provider.default;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function useLocale() {
  return (0, _react.useContext)(_Context.default);
}